import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { Icon } from '../Icon';
import { Link } from '../Link';
export var StyledIcon = styled(Icon)(_templateObject(), function (props) {
  return "\n        font-size: 10px;\n        margin: 0 8px;\n        color: ".concat(props.theme.components.link.unselectedColor, ";\n    ");
});
export var StyledBreadcrumbItem = styled.li(_templateObject2(), function (props) {
  return "\n        display: flex;\n        align-items: center;\n\n        &:last-child {\n            ".concat(Link.Styles.StyledText, " {\n                color: ").concat(props.theme.components.link.color, ";\n            }\n\n            ").concat(StyledIcon, " {\n                display: none;\n            }\n        }\n    ");
});
export var StyledBreadcrumb = styled.ul(_templateObject3(), function () {
  return "\n        background-color: none;\n        display: flex;\n        list-style: none;\n        align-items: center;\n        margin: 0;\n        padding: 0;\n    ";
});